import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../assets/logo.png";

const SplashScreen = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const timer = setTimeout(() => {
            navigate("/home"); // 2 sec baad Home page par le jao
        }, 2000);

        return () => clearTimeout(timer);
    }, [navigate]);

    return (
        <div className="fixed inset-0 bg-white flex items-center justify-center z-50">
            <div className="text-center">
                <img
                    src={logo}
                    alt="OneHexa Logo"
                    className="w-40 sm:w-56 md:w-64 lg:w-80 h-auto animate-splash-logo mx-auto"
                />
            </div>

            <style jsx>{`
        @keyframes splashAnimation {
          0% {
            transform: scale(0.5);
            opacity: 0;
          }
          60% {
            transform: scale(1.2);
            opacity: 1;
          }
          100% {
            transform: scale(1);
            opacity: 1;
          }
        }

        .animate-splash-logo {
          animation: splashAnimation 1.5s ease-out forwards;
        }
      `}</style>
        </div>
    );
};

export default SplashScreen;
